import { render, staticRenderFns } from "./addNewClaims.vue?vue&type=template&id=a61fe068&scoped=true"
import script from "./addNewClaims.vue?vue&type=script&lang=js"
export * from "./addNewClaims.vue?vue&type=script&lang=js"
import style0 from "./addNewClaims.vue?vue&type=style&index=0&id=a61fe068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61fe068",
  null
  
)

export default component.exports